import { render } from "./IconAdv0.vue?vue&type=template&id=2888e4c0&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconAdv0.vue?vue&type=script&lang=js"
export * from "./IconAdv0.vue?vue&type=script&lang=js"
script.render = render

export default script